module.exports = __webpack_public_path__ + "img/NG.fe15d89d.svg";